/**
 * How several values share one cell — in every data table here, in the CSV
 * exports, and in the CSV files the bulk uploads read: "; ".
 *
 * Not ",": names carry commas of their own ("Martin Luther King, Jr.",
 * "Jane Doe, PhD", "Everyone Communicates, Few Connect"), so splitting on a
 * comma turned one author or one book into two. Content team's rule,
 * 22 Oct 2026. Kept in step with LIST_SEPARATOR in pen-space-backend's
 * helpers/listSeparator.js.
 */
export const LIST_SEPARATOR = "; ";

/** "A; B" → ["A", "B"], trimmed, blanks dropped. A comma is part of a value. */
export const splitList = (value) =>
  typeof value === "string"
    ? value.split(";").map((entry) => entry.trim()).filter(Boolean)
    : [];

/** ["A", "B"] → "A; B". */
export const joinList = (values = []) => values.filter(Boolean).join(LIST_SEPARATOR);
